
































import {buildRequestHeader} from "@/shared/services/helper/utils";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

import {Component, Emit, Model, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import RotateImage from "@/shared/components/RotateImage/index.vue";
@Component({
    name: "UploadMultipleImage",
  components: {RotateImage}
})
export default class extends Vue{
    @Prop({ default: '126', type: String})
    readonly width!: string;
    @Prop({ default: '126', type: String })
    readonly height!: string;
    @Prop({ default: "avatar", type: String })
    readonly folder!: string;
    @Prop({ default: "avatar", type: String })
    readonly type!: string;
    @Prop({default: 2, type: Number})
    readonly limit!: number;
    
    @Prop({default: (path: string) => `${process.env.VUE_APP_BASE_URL}upload/${path}`, type: Function})
    readonly pathToUrl!: (path: string) => string;
    
    @PropSync("imageUrl", { type: String, default: "" })
    syncImageUrl!: string;
    
    @Model("change")
    images!: string;
    
    handleChange(changed) {
        const {fileList, file} = changed;
        this.fileList = fileList;
        if (['done', 'removed'].includes(file.status)) {
            this.emitChange(changed);
        }
    }
    
    @Emit("change")
    emitChange({fileList}){
        const result = fileList.map((file: any) => file.url ? file.name : file.response?.data?.path)
            ?.join(',');
        return result;
    }

    deg = 0;
    
    @Watch("images", {immediate: true})
    onImagesChange(val: string) {
        const value = val ? val.split(',').map((item, index) => ({
            uid: (-index).toString(),
            name: item,
            status: 'done',
            url: this.pathToUrl?.(item) ?? item
        })) : [];
        this.fileList = value;
    }
    
    previewVisible = false;
    previewImage = "";
    fileList: any[] = [];
    headers = buildRequestHeader(false as any);
    params = {
        folder: this.folder
    };
    action = `${process.env.VUE_APP_BASE_API}v1/upload/by-file`;

    updated() {
        if (this.fileList.length === this.limit || this.images) {
            const selectE = document.getElementsByClassName('ant-upload-select-picture-card')[0] as any;
            if (!selectE) return;
            selectE.style.border = 'none';
            selectE.style.backgroundColor = '#fff';
        }
    }

    handleCancel() {
        this.previewVisible = false
    }
    
    async handlePreview(file) {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        this.previewImage = file.url || file.preview;
        this.previewVisible = true;
    }

    rotateImg() {
        if (this.deg === 270) this.deg = 0;
        else this.deg += 90;
        const imgE = document.getElementsByClassName("ant-upload-list-item-image")[0] as any;
        if (!imgE) return;
        imgE.style.transform = "rotate("+ this.deg +"deg)"
    }

    logTab(e) {
        console.log(e);
    }
}
